import { FC, ReactElement, useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { getEnv } from './config';
import { sessionLogoutDelay } from './constants';
import { Maintenance } from './containers';
import { isProduction } from './helpers';
import { initTagManager } from './helpers/analytics';
import { initDarkmode } from './helpers/darkmode';
import useTimeout from './hooks/useTimeout';
import RouteComponents, { RoutePaths } from './Routes';

const packageJson = require('../package.json'); // eslint-disable-line

const app_env = getEnv('REACT_APP_APP_ENV');

if (app_env !== 'local' && getEnv('REACT_APP_SENTRY_DSN')) {
    Sentry.init({
        dsn: getEnv('REACT_APP_SENTRY_DSN'),
        release: `${packageJson.name}@${packageJson.version}`,
        environment: app_env,
        integrations: [Sentry.browserTracingIntegration(), Sentry.captureConsoleIntegration({
            levels: ['error'],
        })],
        tracesSampleRate: 1.0,
    });
}

if (app_env === 'production') {
    initTagManager({
        originalLocation: window?.location?.href,
    });
}

// TODO
// - Remove unused translations, to clean up

const App: FC = (): ReactElement => {
    const navigate = useNavigate();

    useEffect(initDarkmode, []);

    useTimeout((): void => {
        if (isProduction) {
            navigate(RoutePaths.logout(), {
                state: { sessionEnd: true },
            });
        }
    }, sessionLogoutDelay);

    if (getEnv('REACT_APP_MAINTENANCE_MODE') === 'true') {
        return <Maintenance />;
    }

    return (
        <Routes>
            {RouteComponents.map(route => <Route {...route} key={route.key} />)}
        </Routes>
    );
};

export default App;
